import React from "react";

export default function TvPreviewFrame({ title = "Live Preview", children }) {
  return (
    <section className="tv-display-preview-frame">
      <div className="tv-display-preview-topbar">
        <span className="tv-display-preview-dot" />
        <span>{title}</span>
      </div>
      <div className="tv-display-preview-screen">{children}</div>
    </section>
  );
}
